/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ChangeRequestHTRequest } from '../models/ChangeRequestHTRequest';
import type { HTDeviceResponse } from '../models/HTDeviceResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class HtService {
    /**
     * HT競合店売価登録API
     * HTからの競合店売価登録を行う
     * @param requestBody
     * @returns HTDeviceResponse OK
     * @throws ApiError
     */
    public static createChangeRequest(
        requestBody: ChangeRequestHTRequest,
    ): CancelablePromise<HTDeviceResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/ht-api/price-registration/save',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * 乖離率取得API
     * 乖離率を取得する
     * @param requestSellingPrice
     * @param edlpSellingPrice
     * @param saratokuSellingPrice
     * @returns void
     * @throws ApiError
     */
    public static getDeviationRate(
        requestSellingPrice: number,
        edlpSellingPrice: number,
        saratokuSellingPrice?: number,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/deviation-rate',
            query: {
                'requestSellingPrice': requestSellingPrice,
                'saratokuSellingPrice': saratokuSellingPrice,
                'edlpSellingPrice': edlpSellingPrice,
            },
            errors: {
                400: `Bad Request`,
                500: `Internal Server Error`,
            },
        });
    }
}
